import 'hammerjs';
// import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppConfig } from './app/lib/config/app-config';

export function getBaseUrl(): string {
  return environment.baseUrl;
}

export function getApiUrl(): string {
  return environment.apiUrl;
}

if (environment.production) {
  // enableProdMode();
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
  { provide: 'API_URL', useFactory: getApiUrl, deps: [] },
  { provide: AppConfig, useValue: new AppConfig(environment) },
];

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
